import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  '3d',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP)
    }),
  },
  {
    name: '3D Walk Through',
    thumbnail: 'tenant/mpi/matterport/1.jpg',
    short: "3D rendering to virtually showcase your property's interior area and size.",
    tenant: TenantId.MAINE_LINE_MEDIA,
    images: [],
    group: 'Digital Media',
  },
);
